<template>
  <div>
    <LocalFileUploaderModalV2
      :modalTitle="$i18nPresenter.t('Import')"
      :isModalVisible="isModalVisible"
      :staticState="staticState"
      :uploadingState="isUploadingFile"
      :uploadError="aiChatbotImportSlidesError"
      :needGenerateQuiz="false"
      :featureName="UploadFeatureName.UPLOAD_V2"
      :instructionText="instructionText"
      @hide="hide()"
      @show-import-options="showImportOptions"
      @remove-file="removeFile"
      @start-import="removeFile"
      hasHeaderDivider
    >
    </LocalFileUploaderModalV2>
    <ImportModalV2
      :isModalVisible="showImportOptionsModal"
      :isUploadFileCalled="isUploadingFile"
      :fileName="selectedFileName"
      @hide="hideImportOptionsModal"
      @remove-file="hideImportModal"
      @start="removeFile"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import utils from '@/util'

import UploadFeatureName from '@/constant/uploadFeatureName'
import { CLOSE_UPLOAD_MODAL } from '@/constant/eventActions/ImportEventActions.js'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'

// components
import LocalFileUploaderModalV2 from '@/components-v2/modals/LocalFileUploaderModalV2.vue'
import ImportModalV2 from '@/components-v2/modals/ImportModalV2.vue'

export default {
  components: {
    ImportModalV2,
    LocalFileUploaderModalV2,
  },
  data() {
    return {
      isModalVisible: false,
      UploadFeatureName,
      showImportOptionsModal: false,
    }
  },
  computed: {
    ...mapState({
      presentationId: (state) => state.presentation?.id,
    }),
    ...mapGetters('aiChatbotImportPptxPdf', [
      'aiChatbotImportSlidesError',
      'aiChatbotUploadedFile',
      'isUploadingFile',
      'sourceFile',
      'selectedFileName',
    ]),
    ...mapGetters('rightNav', ['isAITabActive']),

    staticState() {
      return !this.isUploadingFile
    },

    instructionText() {
      return this.$i18nPresenter.t('uploadInstructionTextHtml')
    },
  },

  mounted() {
    this.show()
    this.setAIChatbotImportSlidesErrorAction('')
    this.setSourceFileAction(null)
  },
  methods: {
    ...mapActions('aiChatbotImportPptxPdf', [
      'setIsAIChatbotImportModalVisibleV2Action',
      'importSlidesAction',
      'setAIChatbotImportSlidesErrorAction',
      'setSourceFileAction',
      'setAIChatbotUploadedFileAction',
      'sendImportDataToAIChatbotAction',
      'setSelectedFileNameAction',
    ]),
    ...mapActions('rightNav', ['openAIPanelAction']),
    ...mapActions('docToSlideGenerator', ['docToSlideUploadFileAction']),

    trackCloseUploadModal() {
      const eventAction = CLOSE_UPLOAD_MODAL
      const eventCategory = EVENT_CATEGORIES_BY_ROUTE_NAME[this.$router?.currentRoute?.name]
      const trackData = {
        eventAction,
        eventCategory,
      }
      utils.trackGA4AndMixpanel(eventAction, trackData)
    },

    show() {
      if (this.aiChatbotUploadedFile || this.isUploadingFile) {
        this.showImportOptionsModal = true
        return
      }
      this.isModalVisible = true
    },

    hide() {
      this.$emit('hide')
      this.setIsAIChatbotImportModalVisibleV2Action(false)
      this.trackCloseUploadModal()
    },
    showImportOptions(fileName) {
      this.setSelectedFileNameAction(fileName)
      this.showImportOptionsModal = true
      this.isModalVisible = false
    },

    hideImportOptionsModal() {
      this.showImportOptionsModal = false
      this.setIsAIChatbotImportModalVisibleV2Action(false)
    },
    hideImportModal() {
      this.showImportOptionsModal = false
      this.isModalVisible = true
    },

    removeFile() {
      this.hideImportOptionsModal()
      this.setAIChatbotUploadedFileAction(null)
      this.setSourceFileAction(null)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
